// extracted by mini-css-extract-plugin
export default {"icon":"icon___Z8KnG","iconDefaultFill":"iconDefaultFill___ZeZX5"};